<template>
    <div class="section" v-show="showChart">
        <h2 class="sectionTitle">Total Time Vessels Spent at Fourchon in the Past Month</h2>
        <div class="sectionContent chartContent centerChart">
            <div class="chart histogram">
                <div id="fourchonHistogram" style="background-color: #22293d;"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Highcharts from 'highcharts';
import {formatShortDate} from '../../helpers/Formatting.js';

export default {
    name: 'trending-fourchon',
    data: () => ({
        showChart: false
    }),
    methods: {
        createChart: function(fourchonInfo) {
            var globv = this;
            globv.showChart = false;
            if (!fourchonInfo) return;

            let bgColor = "#ED4553";
            let data = []
            let date = []

            for (let f of fourchonInfo['bins']) {
                date.push(formatShortDate(f['date']));
                data.push(f['minuteDelta']);
            }

            Highcharts.chart("fourchonHistogram", {
                chart: {
                    type: 'column',
                    backgroundColor: '#22293d'
                },
                credits: {
                    enabled: false,
                    credits: false
                },
                title: {
                    text: null
                },
                tooltip: {
                    pointFormat:
                        '{point.y} minutes'
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    column: {
                        borderColor: bgColor
                    }
                },
                yAxis: {
                    title: {
                        text: "Minutes Spent",
                        style: {
                            color: "#fff"
                        }
                    },
                    gridLineColor: "#666666",
                    labels: {
                        style: {
                            color: "#fff"
                        }
                    }
                },
                xAxis: {
                    categories: date,
                    crosshair: true,
                    labels: {
                        style: {
                            color: "#fff"
                        }
                    }
                },
                series: [{
                    name: 'Minutes Spent',
                    data: data,
                    color: bgColor,
                    dataLabels: {
                        enabled: true,
                        color: "#fff"
                    }
                }]
            });

            globv.showChart = true;
        }
    }
}
</script>